import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import Title from "../../../components/Title";
import { Table } from "react-bootstrap";
import { useFetchHelpPageMutation } from "../../features/apiSlice";
import Title from "../../components/layout/Title";
import { EditButton } from "../../components/layout/CustomTable";


function HelpManagement({subdomain}) {
  const navigate = useNavigate();
//   const { subdomain } = useSelector(selectOptions);
  const [fetchHelpPage, { data, isLoading, error }] =
    useFetchHelpPageMutation();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (subdomain?._id) {
      fetchHelpPage(subdomain._id);
    }
  }, [subdomain, fetchHelpPage]);

  useEffect(() => {
    if (data) {
      setPages([data]);
    }
  }, [data]);

  const column = ["Page", "Actions"];

  return (
    <div>
      <div className="module-mytest-header mt-4">
        <Title>Help Page</Title>
        {/* <div className="d-flex column-gap-3">
          <Link to="website-add-page" style={{ textDecoration: "none" }}>
            <CreateButton btnText="Add Content" onClick={() => {}} />
          </Link>
        </div> */}
      </div>
      <hr />
      <Table bordered responsive>
        <thead>
          <tr>
            {column.map((col, index) => (
              <th
                key={index}
                className="text-center"
                style={{ backgroundColor: "var(--light-blue)" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          
            <tr>
              <td className="text-center">
                Help
              </td>
              <td className="text-center">
                
                  <EditButton
                  onClick={() => navigate(`help-edit-page`)}
                  />
              </td>
            </tr>
          
        </tbody>
      </Table>
     
    </div>
  );
}

export default HelpManagement;
